import Channel from './Channel';

const PRIVATE_CHANNEL_NAME_PREFIX = 'private-';
const CHUNKED_EVENT_PREFIX = 'chunked-';

export default class PrivateChannel extends Channel {

    /**
     * @constructs [PrivateChannel]
     * @property {object} channel - Pusher API channel instance
     */
    constructor(channel) {
        super();
        this.channel = channel;
        this.chunkedMessages = {};

        this.bind = this.bind.bind(this);
        this.unbind = this.unbind.bind(this);
    }

    /**
     * @property {string[]} channelNames - Channel names
     * @return {string[]} Channel names with prefixes
     */
    static addPrefix(channelNames) {
        return (channelNames ?? []).map((channelName) => `${PrivateChannel.channelPrefix}${channelName}`);
    }

    static get channelPrefix() {
        return PRIVATE_CHANNEL_NAME_PREFIX;
    }

    /**
     * @property {string} eventName - name of event on channel
     * @property {function} onMessage - callback function for message receive
     */
    bind(eventName, onMessage) {
        this.channel.bind(eventName, (message) => {
            onMessage(message);
        });

        this.channel.bind(`${CHUNKED_EVENT_PREFIX}${eventName}`, (message) => {
            if (!this.chunkedMessages.hasOwnProperty(message.id)) {
                this.chunkedMessages[message.id] = [];
            }

            const chunks = this.chunkedMessages[message.id];
            chunks[message.index] = message.chunk;

            if (message.total === chunks.length) {
                onMessage(JSON.parse(chunks.join('')));
                delete this.chunkedMessages[message.id];
            }
        });
    }

    /**
     * @property {string} eventName - name of event on channel
     * @property {function} callback - the event handler
     */
    unbind(eventName, callback) {
        this.channel.unbind(eventName, callback);
        this.channel.unbind(`${CHUNKED_EVENT_PREFIX}${eventName}`, callback);
    }
}
